import styled from 'styled-components';
import { Empty } from 'antd';

export const Container = styled(Empty)`
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .ant-empty-image {
    margin-bottom: 1rem;
    height: 200px;
  }

  .ant-btn-primary {
    margin-right: 1rem;
  }
`;
